import styled from 'styled-components';

const AccountCmpContainer = styled.div<React.CSSProperties>`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

export default AccountCmpContainer;
